export default __webpack_public_path__ + "static/media/placeholder_portfolio03-nl-mobile.05414a68.png";